/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module isFunctionType
 */

export default function isFunctionType(value) {
  return typeof value === 'function';
}
